/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_FinishInputs */

const en_cook_finish = /** @type {(inputs: Cook_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const de_cook_finish = /** @type {(inputs: Cook_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Cook_FinishInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_finish = /** @type {((inputs?: Cook_FinishInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_FinishInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_finish(inputs)
	return en_cook_finish(inputs)
});